import muiInputModuleCss from './mui.input.module.css';
import muiTextFieldModuleCss from './mui.text-field.module.css';
import muiInputLabelModuleCss from './mui.text-field.input-label.module.css';

const MuiCss = {
    muiInputModuleCss,
    muiTextFieldModuleCss,
    muiInputLabelModuleCss
}

export default MuiCss;